import { animalPieceTypes } from "../../../const";
import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";

export class ZombificationHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {
    if (params.sideEffects.length === 0) return;

    // Process each zombification side effect
    for (const zombify of params.sideEffects) {
      var pieceToZombify = zombify.piecesToEffect[0];
      const removeOn = params.currentTurnNumber + zombify.effect.activeTurns!;

      pieceToZombify.zombifiedStatus = {
        isZombified: true,
        removeOnTurn: removeOn,
      };
      // Also set the direct isZombified property for compatibility
      pieceToZombify.isZombified = true;

    }
  }
}
